import { render, staticRenderFns } from "./manage_phone.vue?vue&type=template&id=b74d4c6c&scoped=true"
import script from "./manage_phone.vue?vue&type=script&lang=js"
export * from "./manage_phone.vue?vue&type=script&lang=js"
import style0 from "./manage_phone.vue?vue&type=style&index=0&id=b74d4c6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d4c6c",
  null
  
)

export default component.exports